import {
  IconButton,
  Popover as MuiPopover,
  List,
  ListItemText,
  ListItemButton,
  SxProps
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import React, { ReactElement, useState } from 'react';

export type Option = {
  value: any;
  label: string;
  sx?: SxProps;
};

type PopoverComponentProps = {
  options: Option[];
  onOptionClick: (option: Option) => void;
  customIcon?: ReactElement;
  children?: React.ReactNode;
};

const Popover: React.FC<PopoverComponentProps> = ({
  options,
  onOptionClick,
  customIcon,
  children
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOptionClick = (option: Option) => {
    onOptionClick(option);
    handleClose();
  };

  const open = Boolean(anchorEl);

  const clonedChildren = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      // @ts-expect-error: onClick prop is not present in all children
      return React.cloneElement(child, { onClick: handleClick });
    }
    return child;
  });

  return (
    <div>
      {clonedChildren || (
        <IconButton onClick={handleClick}>
          {customIcon ? customIcon : <MoreVertIcon />}
        </IconButton>
      )}
      <MuiPopover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >
        <List>
          {options.map((option, index) => (
            <ListItemButton
              key={`${option.value}-${index}`}
              onClick={() => handleOptionClick(option)}
              sx={option.sx}
            >
              <ListItemText primary={option.label} />
            </ListItemButton>
          ))}
        </List>
      </MuiPopover>
    </div>
  );
};

export { Popover };
